<template>
    <el-dialog
        :before-close="handleDialogClose"
        :close-on-click-modal="false"
        :close-on-press-escape="false"
        :visible.sync="dialogVisible"
        class="custom_form_dialog custom_days_detail_dialog"
        :title="dialogTitle"
        :width="leaveType == 'travel' ? '564px' : leaveType == 'overtime' ? '818px': '800px'"
    >
        <el-table class="custom_table" :data="dayTableData" border height="300px" :max-height="694" ref="detailsTable" v-loading="detailLoading">
            <el-table-column label="开始时间" prop="start_time" width="154">
                <template slot-scope="{ row }">
                    <span>{{ row.start_time }}</span>
                </template>
            </el-table-column>
            <el-table-column label="结束时间" prop="end_time" width="154">
                <template slot-scope="{ row }">
                    <span>{{ row.end_time }}</span>
                </template>
            </el-table-column>
            <!-- 请假 -->
            <template v-if="leaveType == 'leave'">
                <el-table-column label="请假类型" prop="holiday_config_name" width="235">
                    <template slot-scope="{ row }">
                        <span>{{ row.holiday_config_name }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="请假时长（天）" prop="duration" align="right" width="124">
                    <template slot-scope="{ row }">
                        <span>{{ row.duration }}</span>
                    </template>
                </el-table-column>
            </template>
            <!-- 加班 -->
            <template
                v-else-if="
                    leaveType == 'overtime'
                "
            >
                <el-table-column label="加班类型" prop="" width="96">
                    <template slot-scope="{ row }">
                        <span v-if="row.overtime_type == 'work'">工作日加班</span>
                        <span v-else-if="row.overtime_type == 'off'">休息日加班</span>
                        <span v-else-if="row.overtime_type == 'holiday'">节假日加班</span>
                        <span v-else>--</span>
                    </template>
                </el-table-column>
                <el-table-column label="加班时长（天）" prop="" width="124">
                    <template slot-scope="{ row }">
                        <span>{{ row.duration }}</span>
                    </template>
                </el-table-column>
                <el-table-column label="加班计加班费/调休假" prop="" width="156">
                    <template slot-scope="{ row }">
                        <span>计{{ row.compensation_method == "pay" ? "加班费" : "调休假" }} {{ row.compensation_method == "pay" ? row.compensation_duration_pay : row.compensation_duration_comp_leave}}</span>
                    </template>
                </el-table-column>
            </template>
            <!-- 出差明细 -->
            <template v-else>
                <el-table-column label="出差时长（天）" prop="duration" align="right" width="124">
                    <template slot-scope="{ row }">
                        <span>{{ row.duration }}</span>
                    </template>
                </el-table-column>
            </template>
            <el-table-column label="审批详情" prop="" width="84">
                <template slot-scope="{ row }">
                    <span class="link-label" @click="handleClickApprovalDetail(row)">详情</span>
                </template>
            </el-table-column>
        </el-table>
    </el-dialog>
</template>

<script>
import { GetAttendanceDetail } from "@/api";
export default {
    name: "leaveDaysdetails",
    props: {
        dialogVisible: {
            type: Boolean,
            default: false,
        },
        userName: {
            type: String,
            default: "",
        },
        // 天数类型
        leaveType: {
            type: String,
            default: "",
        },
        // 时间
        dateRange: {
            type: Array,
            default: () => []
        },
        // 用户id
        uid: "",
        holiday_config_id: ""
    },
    computed: {
        dialogTitle() {
            let type = "";
            switch (this.leaveType) {
                case "leave":
                    type = "请假";
                    break;
                case "overtime":
                    type = "加班";
                    break;
                case "travel":
                    type = "出差";
                    break;
            }
            return `${this.userName}的${type}明细`;
        },
    },
    data() {
        return {
            detailLoading: false,
            dayTableData: [],
        };
    },
    created() {
        if(this.uid) {
        this.getAttendanceDetail()

        }
    },
    methods: {
        // 弹框关闭
        handleDialogClose() {
            this.$emit("update:dialogVisible", false);
        },
        // 查询记录列表
        getAttendanceDetail() {
            this.detailLoading = true
            let params = {
                type: this.leaveType,
                start_date: this.dateRange && this.dateRange.length ? this.dateRange[0] : "",
                end_date: this.dateRange && this.dateRange.length ? this.dateRange[1] : "",
                uid: this.uid
            }
            if(this.holiday_config_id) {
                params.holiday_config_id = this.holiday_config_id
            }
            GetAttendanceDetail(params).then(res=> {
                if(res.code === 200) {
                   this.dayTableData = res.data || []
                }
                this.detailLoading = false
            }).catch(()=> {
                this.detailLoading = false
            })
        },
        // 查看审批详情
        handleClickApprovalDetail(row) {
            this.$showApprovalDetail({
                approval_id: row.approval_id,
            }).then((res) => {
                // console.log(res);
            });
        },
    },
};
</script>

<style lang="scss">
.custom_days_detail_dialog {
    .el-dialog__body {
        padding: 24px !important;
    }
    .custom_table {
        ::v-deep th.el-table__cell {
            .cell {
                font-weight: 400;
            }
        }
    }
}
</style>
